import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import MainLayout from "./MainLayout";
import Dashboard from "./Dashboard";
import Add from "./Add";
import Tareas from "./Tareas";
import TaskStudioPage from "./TaskStudioPage";
import MonthlyFilters from "./MonthlyFilters";
import SharedExpenses from "./SharedExpenses";
import SettingsPage from "./SettingsPage";
import MetricsPage from "./MetricsPage";
import MetasPage from "./MetasPage";
import PomodoroPage from "./PomodoroPage";
import SaludPage from "./SaludPage";
import ComunidadPage from "./ComunidadPage";
import ApoyarPage from "./ApoyarPage";
import MonitoreoPage from "./MonitoreoPage";
import { COMUNIDAD_HABILITADA } from "../config";

import LoginPage from "./LoginPage";
import SignupPage from "./SignupPage";
import ForgotPasswordPage from "./ForgotPasswordPage";
import ResetPasswordPage from "./ResetPasswordPage";
import PlansPage from "./PlansPage";

function AppRoutes({
  token,
  onAuthSuccess,
  onLogout,
  movimientos,
  onUpdate,
  movementToEdit,
  setMovementToEdit,
  refreshKey,
  panelCurrency,
  onPanelCurrencyChange,
  theme,
  onThemeToggle,
  activeWorkspace,
  onWorkspaceChange,
  ...authProps
}) {
  /* =====================================================
     🔓 RUTAS PÚBLICAS (NO LOGUEADO)
  ===================================================== */
  if (!token) {
    return (
      <Routes>
        {/* Login es la pantalla inicial */}
        <Route
          path="/"
          element={<Navigate to="/login" />}
        />

        <Route
          path="/login"
          element={
            <LoginPage
              onAuthSuccess={onAuthSuccess}
              theme={theme}
              onThemeToggle={onThemeToggle}
            />
          }
        />

        <Route
          path="/register"
          element={
            <SignupPage
              onAuthSuccess={onAuthSuccess}
              theme={theme}
              onThemeToggle={onThemeToggle}
            />
          }
        />

        <Route
          path="/forgot-password"
          element={
            <ForgotPasswordPage
              theme={theme}
              onThemeToggle={onThemeToggle}
            />
          }
        />

        <Route
          path="/planes"
          element={
            <PlansPage
              theme={theme}
              onThemeToggle={onThemeToggle}
            />
          }
        />

        <Route
          path="/reset-password"
          element={
            <ResetPasswordPage
              theme={theme}
              onThemeToggle={onThemeToggle}
            />
          }
        />

        {/* Cualquier otra ruta → login */}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    );
  }

  /* =====================================================
     🔒 RUTAS PRIVADAS (LOGUEADO)
  ===================================================== */
  return (
    <Routes>
      <Route
        path="/"
        element={
          <MainLayout
           token={token}
            onLogout={onLogout}
            movimientos={movimientos}
            refreshKey={refreshKey}
            onUpdate={onUpdate}
            panelCurrency={panelCurrency}
            onPanelCurrencyChange={onPanelCurrencyChange}
            setMovementToEdit={setMovementToEdit}
            theme={theme}
            onThemeToggle={onThemeToggle}
            activeWorkspace={activeWorkspace}
            onWorkspaceChange={onWorkspaceChange}
          />
        }
      >
        {/* Dashboard */}
        <Route
          index
          element={
            <Dashboard
              token={token}
              refreshKey={refreshKey}
              onMovementUpdate={onUpdate}
              movementToEdit={movementToEdit}
              setMovementToEdit={setMovementToEdit}
              movimientos={movimientos}
              currentCurrency={panelCurrency}
              onCurrencyChange={onPanelCurrencyChange}
              activeWorkspace={activeWorkspace}
              {...authProps}
            />
          }
        />

        {/* Agregar / editar movimientos */}
        <Route
          path="add"
          element={
            <Add
              onMovementAdded={onUpdate}
              movementToEdit={movementToEdit}
              defaultCurrency={panelCurrency}
              {...authProps}
            />
          }
        />

        {/* Notas / tareas */}
        <Route
          path="tareas"
          element={
            <Tareas
              refreshKey={refreshKey}
              onTaskSaved={onUpdate}
              activeWorkspace={activeWorkspace}
            />
          }
        />

        <Route
          path="notas"
          element={<TaskStudioPage activeWorkspace={activeWorkspace} />}
        />

        <Route
          path="filtros"
          element={
            <MonthlyFilters
              movimientos={movimientos}
              currentCurrency={panelCurrency}
              onCurrencyChange={onPanelCurrencyChange}
              onMovementUpdate={onUpdate}
              onEditMovement={setMovementToEdit}
            />
          }
        />

        <Route
          path="metricas"
          element={
            <MetricsPage
              movimientos={movimientos}
              currentCurrency={panelCurrency}
              onCurrencyChange={onPanelCurrencyChange}
            />
          }
        />

        <Route path="metas" element={<MetasPage activeWorkspace={activeWorkspace} />} />
        <Route path="compartidos" element={<SharedExpenses />} />
        <Route path="pomodoro" element={<PomodoroPage />} />
        <Route path="salud" element={<SaludPage />} />
        {COMUNIDAD_HABILITADA ? (
          <Route path="comunidad" element={<ComunidadPage />} />
        ) : null}
        <Route path="ajustes" element={<SettingsPage theme={theme} onThemeToggle={onThemeToggle} />} />
        <Route path="perfil" element={<SettingsPage mode="perfil" currentWorkspace={activeWorkspace} theme={theme} onThemeToggle={onThemeToggle} />} />
        <Route path="apoyar" element={<ApoyarPage />} />
        {/* Panel admin: no aparece en el nav; el backend devuelve 403 si no sos ADMIN_EMAILS */}
        <Route path="monitoreo" element={<MonitoreoPage />} />

        {/* Cualquier otra ruta privada → dashboard */}
        <Route path="*" element={<Navigate to="/" />} />
      </Route>
    </Routes>
  );
}

export default AppRoutes;
